import { generateMultipleChoiceContent } from "../../multiplechoice/logic/content";
import { GenerateContentOptions } from "../../types";
import { Content, ContentSource } from "../types";

export function generateContent(
  source: ContentSource,
  { testingActive }: GenerateContentOptions
): Content {
  const { question, correctAnswer, wrongAnswers, ...rest } = source;

  if (testingActive) {
    const multipleChoiceContent = generateMultipleChoiceContent({
      question,
      correctAnswer,
      wrongAnswers
    } as ContentSource);
    return { ...rest, ...multipleChoiceContent };
  } else {
    return { ...rest } as unknown as Content;
  }
}
